<template>

    <v-page-section>
        <template #title>Billing Details</template>
        <template #body>
            <transition name="modal">
                <v-modal-card-update v-if="showModal === 'card-update'" @changed="$emit('changed')" />
            </transition>
            <v-form-group label="Payment Information" caption="Card on file.">
                <v-form-group dir="ver">
                    <p><span>{{ card.brand + ' ending in ' + card.last4 + ' • exp ' + card.exp_month + '/' + card.exp_year }}</span></p>
                </v-form-group>
                <v-button size="sm" @click.native="$store.commit('showModal', 'card-update')">Update Card</v-button>
            </v-form-group>
            <v-form-group label="Billing Address" caption="The address displayed on all invoices.">
                <v-form-group dir="ver" label="Country">
                    <v-select class="w-500" :model="params.country || ''" @input="setCountry($event)">
                        <option value="">Select Country</option>
                        <optgroup>
                            <option value="US">United States</option>
                            <option value="CA">Canada</option>
                        </optgroup>
                        <optgroup>
                            <option v-for="c in countries" :key="c.value" :value="c.value">{{ c.label }}</option>
                        </optgroup>
                    </v-select>
                </v-form-group>
                <template v-if="params.country">
                    <v-form-group dir="ver" label="Line 1">
                        <v-input class="w-500" placeholder="Street Name" :model="params.line1" @input="params.line1 = $event" />
                    </v-form-group>
                    <v-form-group dir="ver" label="Line 2">
                        <v-input class="w-500" placeholder="City, Region, Postal Code" :model="params.line2" @input="params.line2 = $event" />
                    </v-form-group>
                    <v-form-group dir="ver" label="Note">
                        <v-textarea class="w-500" placeholder="Optional note..." :model="params.note" @input="params.note = $event" />
                    </v-form-group>
                </template>
                <v-form-group dir="ver">
                    <v-button size="sm" :loading="loading" @click.native="updateBillingAddress">Update Billing Address</v-button>
                </v-form-group>
            </v-form-group>
        </template>
    </v-page-section>

</template>

<script>

import { countries } from 'countries-list';
import CompanyApi from '@api/CompanyApi';
import ModalCardUpdate from '@modals/misc/ModalCardUpdate';

export default {

    components: {
        'v-modal-card-update': ModalCardUpdate,
    },

    props: {
        company: {
            type: Object,
            required: true,
        },
        card: {
            type: Object,
        },
    },

    data() {
        return {
            loading: false,
            params: {},
        }
    },

    computed: {

        countries() {
            let results = [];
            for (let c in countries) {
                results.push({ value: c, label: countries[c].name });
            }
            return results.sort(function(a, b) {
                return a.label.localeCompare(b.label)
            });
        },

    },

    created() {
        if (this.company.billing_address) {
            this.params = this.company.billing_address;
        }
    },

    methods: {

        setCountry(val) {
            this.params = { country: val };
        },

        updateBillingAddress() {
            this.loading = true;
            CompanyApi.updateBillingAddress(this.company.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>